import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { isMinimumAgeReached } from "../../BirthDateFormInputs";
import { DayInput } from "../DayInput/DayInput";
import { MonthInput } from "../MonthInput/MonthInput";
import { YearInput } from "../YearInput/YearInput";
export const BirthDateDropdowns = ({ dayPlaceholder, monthPlaceholder, yearPlaceholder, minimumAge, format, }) => {
    const { watch, setError, clearErrors } = useFormContext();
    watch((values) => {
        const year = Number(values?.year?.value);
        const month = Number(values?.month?.value);
        const day = format === "dd/mm/yyyy" ? Number(values?.day?.value) : 1;
        if (day && month && year && !isMinimumAgeReached({ year, month, day, minimumAge })) {
            setError("minimumAge", {});
        }
        else {
            clearErrors("minimumAge");
        }
    });
    return (_jsxs(_Fragment, { children: [format !== "mm/yyyy" && _jsx(DayInput, { type: "select", placeholder: dayPlaceholder }), _jsx(MonthInput, { type: "select", placeholder: monthPlaceholder }), _jsx(YearInput, { minimumAge: minimumAge, type: "select", placeholder: yearPlaceholder })] }));
};
//# sourceMappingURL=BirthDateDropdowns.js.map